<template>
  <div class="p-8">
    <form @submit.prevent="add">
      <div class="flex pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            New Employee
          </h3>
          <p class="text-gray-600">Add a new employee!</p>
        </div>
        <div class="w-2/3">
          <div class="flex space-x-4">
            <label class="block w-1/2">
              <span class="text-gray-700">Name</span>
              <input
                v-model="name"
                class="form-input block w-full"
                placeholder="Employee name"
              />
            </label>
            <label class="block w-1/2">
              <span class="text-gray-700">Phone</span>
              <input
                v-model="phone"
                minlength="9"
                maxlength="9"
                class="form-input block w-full rounded-l-none"
                placeholder="Phone number"
              />
            </label>
          </div>
          <div class="mt-4">
            <button
              :disabled="busy"
              class="w-32 py-2 text-ilift-900 rounded shadow"
              :class="
                busy
                  ? 'bg-ilift-200 cursor-not-allowed'
                  : 'bg-ilift-500 hover:bg-ilift-600'
              "
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      busy: false,
      name: "",
      phone: ""
    };
  },
  computed: {
    corporateId() {
      return this.$store.state.auth.account.corporate._id;
    }
  },
  methods: {
    add() {
      var intPhone = parseInt(this.phone);
      if (intPhone && intPhone.toString().length == 9 && this.name) {
        this.busy = true;
        this.$http
          .post("/employees", {
            name: this.name,
            phone: "+251" + intPhone.toString(),
            corporate: this.corporateId
          })
          .then(() => {
            window.flash({
              body: "Employee added successfully!",
              type: "success"
            });
            this.$router.push("/corporate/employees");
          })
          .catch(err => {
            console.log(err);
            window.flash({ body: "Failed to add employee!", type: "error" });
          })
          .finally(() => (this.busy = false));
      }
    }
  }
};
</script>
